<template>
  <div class="layout-tavolo-mobile">
    <v-main>
      <!-- svincolati -->
      <v-dialog
        eager
        max-width="450"
        v-model="svincolatiDrawer"
        content-class="asta-svincolati-mobile-dialog"
      >
        <v-card>
          <v-card-title class="secondary white--text">
            <span class="font-hemi-head">SVINCOLATI</span>

            <v-spacer></v-spacer>
            <v-btn icon @click="toggleSvincolati">
              <v-icon class="white--text">close</v-icon>
            </v-btn>
          </v-card-title>
          <asta-svincolati class="navy"></asta-svincolati>
        </v-card>
      </v-dialog>
      <!-- tavolo  -->
      <div class="asta-tavolo-mobile">
        <asta-tavolo></asta-tavolo>
      </div>
      <!-- chat  -->
      <div class="asta-chat-messages-mobile">
        <asta-chat-messages></asta-chat-messages>
      </div>
      <!-- chat -->
      <div class="asta-chat-input-mobile">
        <asta-chat-input></asta-chat-input>
      </div>
      <!-- floating buttons -->
      <div class="floating-buttons-mobile">
        <v-btn
          color="gradient-green"
          rounded
          large
          @click="toggleSvincolati"
        >
          <div class="floating-button-content d-flex flex-column justify-center align-center white--text">
            <v-icon>groups </v-icon>
            <div class="font-hemi-head floating-button-label">Svincolati</div>
          </div>
          <!-- <v-icon class="ma-n3">chevron_left</v-icon>
          <v-icon class="ma-2">groups </v-icon> -->
        </v-btn>

        <v-btn
          color="gradient-green"
          rounded
          large
          @click="showDialogPlan"
        >
          <div class="floating-button-content d-flex flex-column justify-center align-center white--text">
            <v-icon>paid</v-icon>
            <div class="font-hemi-head floating-button-label">
              Pianificazione
            </div>
          </div>
        </v-btn>

        <v-btn
          color="gradient-green"
          rounded
          large
          @click="showDialogRoseLega"
        >
          <div class="floating-button-content d-flex flex-column justify-center align-center white--text">
            <v-icon>view_column</v-icon>
            <div class="font-hemi-head floating-button-label">Rose lega</div>
          </div>
        </v-btn>
      </div>
    </v-main>
  </div>
</template>

<script>
import AstaTavolo from "../AstaTavolo.vue";
import AstaSvincolati from "../AstaSvincolati";
import AstaChatMessages from "../AstaChatMessages";
import AstaChatInput from "../AstaChatInput";
import mixins from "../../js/mixins";
import db from "../../js/db";

export default {
  name: "layout-tavolo-mobile",
  mixins: [mixins],
  components: {
    AstaTavolo,
    AstaSvincolati,
    AstaChatMessages,
    AstaChatInput,
  },
  data() {
    return {
      // value: Constants.ASTA_TABS.MAIN,
      drawer: true,
      svincolatiDrawer: false,
      // Config: Config
    };
  },

  methods: {
    toggleSvincolati() {
      this.svincolatiDrawer = !this.svincolatiDrawer;
    },
    closeSvincolati() {
      this.svincolatiDrawer = false;
    },
    showDialogPlan() {
      db.emit("showDialogPlan");
    },
    showDialogRoseLega() {
      db.emit("showDialogRoseLega");
    },
  },
  mounted() {
    console.log("--> LayoutTavoloMobile ready.");
    db.on("closeSvincolati", this.closeSvincolati);
  },
  destroyed() {
    console.log("<-- LayoutTavoloMobile destroyed.");
    db.off("closeSvincolati", this.closeSvincolati);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.asta-tavolo-mobile {
  position: absolute;
  right: 0;
  top: 0px;
  left: 0;
  // bottom: 70%;
}
.asta-chat-messages-mobile {
  position: absolute;
  top: 15%; // serve per evitare che l'user tenti di scrollare sui messaggi che nn scrollerebbero
  bottom: 0px;
  left: 0;
  right: 0;
  .chat {
    padding-bottom: 90px;
  }
}
.asta-chat-input-mobile {
  position: fixed;
  bottom:90px;
  left: 15px;
  right: 15px;
}
.floating-buttons-mobile {
  position: fixed;
  bottom: 35px;
  left: 0px;
  right: 0px;
  display: flex;
  justify-content: center;
  gap: 5px;
  align-items: center;
  padding: 0 10px;
  .v-btn {
    flex: 1 1 0;
    min-width: 0;
  }
  .v-btn::v-deep .v-btn__content {
    max-width: 100%;
    min-width: 0;
    overflow: hidden;
    width: 100%;
  }
  .floating-button-content {
    min-width: 0;
    width: 100%;
  }
  .floating-button-label {
    display: block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    font-size: 12px;
  }
}
.asta-svincolati-mobile {
  max-width: 400px !important;
  width: 90% !important;
  .svincolati {
    margin-top: 25px;
    margin-bottom: 40px;
  }
}
.asta-rose-mobile {
  max-width: 400px !important;
  width: 90% !important;
  transform: none !important; // senza questa linea il layout sballa su se su dev-tools clcci sull'iconcina "toggle device toolbar"
}

.v-main {
  height: 100vh;
  // background-image: url(/static/img/bg-seamless.png);
  // background-repeat: repeat;
  // background-color: white;
  background-color: var(--dark_main_bk);
  // background-image: linear-gradient(
  //   0deg,
  //   var(--v-navy-darken2),
  //   var(--v-navy-darken1) 300px
  // );
}

/* .v-bottom-navigation .v-btn--active {
  border-bottom: 5px solid var(--v-primary-darken2);
} */
</style>
